import React from "react";
import {withNamespaces} from "react-i18next";
import {Alert, Button, ButtonGroup, Spinner} from "react-bootstrap";
import {Link} from "react-router-dom";
import {claimTypes} from "../../../../constants/claim.constants";
import {connect} from "react-redux";

const WidgetPowerManagement = ({dashboard, exhibitionState, callbackAction, user, claim, t}) => {
    const claimAccess = user[`c_${claim}`] || null;
    if(claimAccess === claimTypes.NONE) {
        return (
            // return when claims is none
            <React.Fragment/>
        )
    }

    const handleAction = (type) => {
        callbackAction(type);
    };

    return (
        <React.Fragment>
            {dashboard?.powerManagementList.map((item, idx) => {
                return (
                    <div className="mt-2" key={idx}>
                        <div className="card">
                            <div className="card-header">
                                <b><span className="card-title"> {t('power-management-title')} - <b>{ item.label }</b> </span></b>
                            </div>
                            {/*render card*/}
                            {item ? (
                                <div className="card-body">
                                    {
                                        (item?.groupState) ? (
                                            <Alert variant={!item.groupState.trigger.includes('manual') ? 'success' : 'warning'}>
                                                { !item.groupState.trigger.includes('manual') ?
                                                    `${ t(item.groupState.trigger.toLowerCase() + '-working') } | ${t('exhibition-state')} : ${ t(item.groupState.state.toLowerCase()) }` :
                                                    `${ t('manual-working') } | ${ t('exhibition-state') } : ${ t(item.groupState.state.toLowerCase()) }`
                                                }
                                            </Alert>
                                            ) : (
                                            <Alert>
                                                Loading
                                            </Alert>
                                    )}
                                    <ButtonGroup size="lg" className="m-2">
                                        <Button variant={'outline-secondary'}
                                                active={(item.groupState.state.toLowerCase() === "on") && item.groupState.trigger.includes('manual')}
                                                disabled={claimAccess === (claimTypes.READ)}
                                                onClick={() => handleAction(`ManualSetState/on?groupid=${item.deviceGroupId}`)}>
                                            {t('on')}
                                        </Button>
                                        <Button variant={'outline-secondary'}
                                                active={(item.groupState.state.toLowerCase() === "off") && item.groupState.trigger.includes('manual')}
                                                disabled={claimAccess === (claimTypes.READ)}
                                                onClick={() => handleAction(`ManualSetState/off?groupid=${item.deviceGroupId}`)}>
                                            {t('off')}
                                        </Button>
                                    </ButtonGroup>

                                    <ButtonGroup size="lg" className="m-2">
                                        <Button variant="primary"
                                                disabled={!item.groupState.trigger.includes('manual') || claimAccess === (claimTypes.READ)}
                                                onClick={() => handleAction(`RestoreScheduleDeviceGroup/${item.deviceGroupId}`)}>
                                            {t('restore-schedule')}
                                        </Button>
                                    </ButtonGroup>

                                    <ButtonGroup size="lg" className="m-2">
                                        <Link to={`/panel/device-group/${item.deviceGroupId}/schedule`} className="btn btn-success">
                                            {t('schedule-settings')}
                                        </Link>
                                    </ButtonGroup>
                                </div>
                            ) : (
                                <div className="card-body">
                                    <Spinner animation={"border"}/>
                                </div>
                            )}
                            {/*render card end */}
                        </div>
                    </div>
                )
            })
            }
        </React.Fragment>
    )
};
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetPowerManagement));
